import React from "react";

import "./geoTable.scss";
import GeoPost from "./GeoPost";
import { useQuery } from "react-query";

import api  from "../../services/api";

const retrievePosts = async () => {
  const res = await api.get("/api/osint/sample/geo-locations/");
  return res.data;
};
const GeoTable = () => {
  const {
    data: posts,
    error,
    isLoading,
  } = useQuery("geoPostsData", retrievePosts);

  if (isLoading) return <div>Fetching posts...</div>;
  if (error) return <div>An error occurred: {error.message}</div>;

  return (
    <div className="posts">
      {posts.map((post) => (
        <GeoPost post={post} key={post.id} />
      ))}
    </div>
  );
};

export default GeoTable;